import { PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { PendingUserList } from '~/features/PendingUserList';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  return (
    <div className={styles.screen}>
      <ClientSideMenu />
      <div className={styles.content}>
        <PageHeader variant='title' title='初回ログイン未完了者' />
        <main className={styles.body}>
          <Suspense fallback={<Shimmer />}>
            <PendingUserList />
          </Suspense>
        </main>
      </div>
    </div>
  );
};
